import { Func } from 'interfaces/func';
import { SubscribableOrNullableValue } from 'knockout';
import { withEffects } from 'mixins/withEffects';

export default class NodeAttributeTracker {
    private effects = withEffects();

    constructor(node: SubscribableOrNullableValue<Node>, attribute: string, predicate: Func<boolean, [$node: JQuery<Node>, oldValue: string | null]>, action: Action<[JQuery<Node>]>) {
        this.effects.register(node => {
            if (node != undefined) {
                const $node = $(node);

                const observer = new MutationObserver(mutations => {
                    mutations.forEach(mutation => {
                        if (predicate($node, mutation.oldValue))
                            action($node);
                    });
                });

                observer.observe(node, { attributes: true, attributeOldValue: true, attributeFilter: [attribute] });

                if (predicate($node, null))
                    action($node);

                return () => observer.disconnect();
            }
        }, [node]);
    }

    dispose() {
        this.effects.dispose();
    }
}